/**
 * Score comparison cards with delta indicators.
 */

import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface ScoreComparison {
  label: string;
  scan1: number;
  scan2: number;
  delta: number;
  /** When true, higher is worse (AIVSS, CVSS). When false, higher is better (CRS). */
  higherIsWorse?: boolean;
  maxScore?: number;
}

interface ScoreDeltaProps {
  scores: ScoreComparison[];
}

function formatDelta(delta: number): string {
  if (delta === 0) return '0';
  return delta > 0 ? `+${delta.toFixed(1)}` : delta.toFixed(1);
}

const ScoreDelta = ({ scores }: ScoreDeltaProps) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
    {scores.map((s) => {
      const improved = s.higherIsWorse ? s.delta < 0 : s.delta > 0;
      const regressed = s.higherIsWorse ? s.delta > 0 : s.delta < 0;

      return (
        <div key={s.label} className="bg-zinc-800/50 border border-zinc-700 rounded-lg p-4">
          <p className="text-xs text-zinc-400 uppercase tracking-wider mb-2">{s.label}</p>
          <div className="flex items-baseline gap-2">
            <span className="text-zinc-500 text-sm">{s.scan1.toFixed(1)}</span>
            <span className="text-zinc-600">→</span>
            <span className="text-white font-semibold text-lg">{s.scan2.toFixed(1)}</span>
          </div>
          <div className={`flex items-center gap-1 mt-1 text-sm ${
            improved ? 'text-green-400' : regressed ? 'text-red-400' : 'text-zinc-500'
          }`}>
            {improved ? <TrendingDown className="w-3.5 h-3.5" /> :
             regressed ? <TrendingUp className="w-3.5 h-3.5" /> :
             <Minus className="w-3.5 h-3.5" />}
            <span>{formatDelta(s.delta)}</span>
          </div>
        </div>
      );
    })}
  </div>
);

export default ScoreDelta;
